import { render, staticRenderFns } from "./globalNewParams.vue?vue&type=template&id=6586947b&scoped=true"
import script from "./globalNewParams.vue?vue&type=script&lang=js"
export * from "./globalNewParams.vue?vue&type=script&lang=js"
import style0 from "./globalNewParams.vue?vue&type=style&index=0&id=6586947b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6586947b",
  null
  
)

export default component.exports